import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../style/NavBar.css'
import NavItems from './NavItems';
import logo from './../../assets/iconNav.png'
const NavBar = () =>{

  return(
  <>
  <nav className="navbar navbar-expand-lg navbar-dark bgNav">
      
  <div className = "container-fluid">
         <Link className="navbar-brand" to = "/">
           <img src={logo} alt="" className="d-inline-block"/>
            <span className = "mx-2">nanowebmx </span>
          </Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
      </button>
      <div className = "collapse navbar-collapse" id="navbarSupportedContent">                    
          <NavItems/>
      </div>
  </div>

  </nav>
  <div className=" navbar-expand-lg bgNav2 text-white text-center py-1">
    by: <a href ="https://twitter.com/sm__alfredo" rel="noreferrer" target="_blank" className="text-white">
      @sm__alfredo<br/>
      </a>
   </div>
  </>
)}
export default NavBar
   